import PropTypes from "prop-types";

import EditIcon from "@mui/icons-material/Edit";

function EditCell({ row = {}, onEdit = () => {} }) {
    return (
        <EditIcon
            color="primary"
            style={{ cursor: "pointer" }}
            onClick={() => onEdit(row)}
        />
    );
}

EditCell.propTypes = {
    row: PropTypes.object,
    onEdit: PropTypes.func,
};

export default EditCell;
